<template>
  <section class="forHome finest">
    <Grid class="finest-grid forHome">
     <div class="grid-column x4">
        <div class="content txt">
          <h2 class="line-height-fix">Work in progress</h2>
        </div>
      </div>
      
    <div class="grid-column x6 shrinkTo4">
      <div class="content txt">
          <p class="items">
           Working with <a href="http://www.birdsonmars.com" target="_blank">Birds on Mars</a> on a confidential client project to make analytic data human accessible.
           Together with <a href="https://www.linkedin.com/in/johannes-schardt/" target="_blank">Johannes</a> from <a href="http://www.precious-forever.com" target="_blank">precious</a> and <a href="https://www.linkedin.com/in/samuelguenther/" target="_blank">Samuel</a> from his client <a href="http://www.visable.com" target="_blank">Visable</a>, we are creating the technical and conceptional foundation for a scalable multibrand, token-based design system. <br><br> </p>
      </div>
    </div>
      <div class="grid-column x4">
        <div class="content txt">
          <h2 class="line-height-fix">Accomplishments</h2>
        </div>
      </div>
      <div class="grid-column x6 shrinkTo4">
        <div class="content txt">
          <p class="items">
            Created a design-system
            <span>with Fielmann.</span>
            <br />A walkable
            omnichannel prototype with
            <span>digital devices for Fielmann.</span>
            <br />Service app for ordering contacts
            <span>online with Fielmann.</span>
            <br />Tablet based measurement
            system
            <span>with Fielmann Ventures.</span>
            <br />Building web apps
            with Picobello.
            <br />Build the proof of concept of
            <span>an website creator.</span>

            <br />
          </p>
        </div>
      </div>
    </Grid>
  </section>
</template>
<script>
import Grid from "./Grid.vue";
export default {
  name: "Finest",
  components: {
    Grid
  }
};
</script>
<style scoped>
.finest {
}

.finest-grid {
  flex-wrap: nowrap;
  align-items: flex-start;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
}

.items {
  font-size: 30px;
  line-height: 45px;
  letter-spacing: -0.75px;
}

.items span {
  white-space: nowrap;
}

@media only screen and (max-width: 576px) {
  .items {
    line-height: 35px;
    letter-spacing: -0.3px;
    font-size: 25px;
  }
  .items span {
    white-space: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Section.Finest.vue